module.exports = __webpack_public_path__ + "static/media/02-2-galeria-02-zegna-mobile@2x.2060e14d.jpg";